import { useEffect, useState } from 'react';

export const MAX_WIDTH_S = '(max-width: 720px)';

export const useMediaQuery = (query: string) => {
    const [mathces, setMatches] = useState(() =>
        typeof window !== 'undefined' ? window.matchMedia(query).matches : false,
    );

    useEffect(() => {
        const media = window.matchMedia(query);
        const listener = () => setMatches(media.matches);

        media.addEventListener('change', listener);

        return () => media.removeEventListener('change', listener);
    }, [query]);

    return mathces;
};
